import type { ObjectDirective } from "vue";

const resize: ObjectDirective = {
  mounted: (el, binding) => {
    let width = "",
      height = "";
    function isReize() {
      const style = document.defaultView?.getComputedStyle(el);
      if (style) {
        if (width !== style.width || height !== style.height) {
          binding.value(style.width, style.height);
        }
        width = style.width;
        height = style.height;
      }
    }
    el.__vueSetInterval__ = setInterval(isReize, 200);
  },
  unmounted: (el) => {
    clearInterval(el.__vueSetInterval__);
  }
};
export default resize;
